import React, { PropsWithChildren } from 'react';
import { MeatballMenu } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { UpdateExternalUrlItemHandler } from '../types';
import { ExternalUrlItem, ExternalUrlsValidation } from 'app/area/external-url-groups/form/types-store';
import { ExternalUrlGroupsTranslation } from 'app/area/external-url-groups/constants';
import styles from './external-url-meatball.scss';

interface ExternalUrlMeatballProps {
  externalUrlItem: ExternalUrlItem;
  prevElementSequence: number;
  nextElementSequence: number;
  validation: ExternalUrlsValidation;
  translation: ExternalUrlGroupsTranslation;
  onAddExternalUrl: (sequence?: number) => void;
  updateExternalUrl: UpdateExternalUrlItemHandler;
  deleteExternalUrl: (extenalUrlId: number) => void;
  deleteAllExternalUrls: () => void;
  onHideDetails: () => void;
}

export const ExternalUrlMeatball = ({
  externalUrlItem, prevElementSequence, nextElementSequence,
  onAddExternalUrl, updateExternalUrl, deleteExternalUrl, onHideDetails, deleteAllExternalUrls,
  validation, translation
}: PropsWithChildren<ExternalUrlMeatballProps>) => {

  const addExternalUrlsHandler = () => {
    onAddExternalUrl(externalUrlItem.sequence);
  };
  
  const onMoveUp = () => {
    updateExternalUrl(externalUrlItem.code?.value,
      { ...externalUrlItem, sequence: prevElementSequence },
      validation[externalUrlItem?.code?.value]);
  };

  const onMoveDown = () => {
    updateExternalUrl(externalUrlItem.code?.value,
      { ...externalUrlItem, sequence: nextElementSequence },
      validation[externalUrlItem?.code?.value]);
  };

  const onRemove = () => {
    deleteExternalUrl(externalUrlItem.code?.value);
  };

  return <MeatballMenu className={styles.meatball} closeAfterClick={true} onExpandMenu={onHideDetails}>
    <li>
      <button className="dropdown-item"
        onClick={addExternalUrlsHandler}>
        {translation.external_url_add_option}
      </button>
    </li>
    {isDefinedIncludingZero(prevElementSequence) && <li>
      <button className="dropdown-item"
        onClick={onMoveUp}>
        {translation.external_url_move_up_option}
      </button>
    </li>}
    {isDefinedIncludingZero(nextElementSequence) && <li>
      <button className="dropdown-item"
        onClick={onMoveDown}>
        {translation.external_url_move_down_option}
      </button>
    </li>}
    <li>
      <button className="dropdown-item"
        onClick={onRemove}>
        {translation.remove}
      </button>
    </li>
    <li>
      <button className="dropdown-item"
        onClick={deleteAllExternalUrls}>
        {translation.remove_all}
      </button>
    </li>
  </MeatballMenu>;
};
